import { type FieldContext, type FieldOptions, type RuleExpression, useField } from 'vee-validate';
import { computed, type MaybeRef, type MaybeRefOrGetter, ref } from 'vue';

const blurValidatedField = <T>(fieldContext: FieldContext<T>) => {
  const isBlurTriggered = ref(false);

  // Bij een change op de waarde standaard geen validatie uitvoeren.
  // Behalve als er al een fout was geconstateerd dan wel valideren zodat de fout verdwijnt zodra de gebruiker een juiste waarde heeft ingevoerd.
  // Of wanneer de waarde door een blur is gewijzigd
  const handleChange = (val: T) => {
    const shouldSetErrors = isBlurTriggered.value || !!fieldContext.errorMessage.value;
    isBlurTriggered.value = false;
    fieldContext.handleChange(val, shouldSetErrors);
  };

  // Bij een blur altijd valideren
  const handleBlur = (event: Event | undefined = undefined, shouldValidate = true) => {
    isBlurTriggered.value = shouldValidate;
    fieldContext.handleBlur(event, shouldValidate);
  };

  const value = computed({
    get: () => fieldContext.value.value,
    set: (val: T) => handleChange(val),
  });
  return {
    ...fieldContext,
    value,
    handleChange,
    handleBlur,
  };
};

export const useBlurValidatedField = <TValue = unknown>(
  path: MaybeRefOrGetter<string>,
  rules?: MaybeRef<RuleExpression<TValue>>,
  opts?: Partial<FieldOptions<TValue>>,
) => {
  const field = useField<TValue>(path, rules, opts);
  return blurValidatedField(field);
};
